import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPosts } from '../services/blogApi';

const E  = '#7C4DFF';
const ED = '#6030E8';
const N  = '#0A2540';

export default function BlogSection() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPosts(0, 3)
      .then(res => setPosts(res.data.content || res.data))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <section className="section section-alt">
      <div className="container" style={{ textAlign: 'center' }}>
        <div style={{ color: E, fontSize: '2rem' }}>
          <i className="fas fa-spinner fa-spin" />
        </div>
      </div>
    </section>
  );

  if (!posts.length) return null;

  return (
    <section id="blog" className="section section-alt">
      <div className="container">
        <div className="section-header">
          <h2>Latest from the Blog</h2>
          <div className="section-divider" />
          <p style={{ marginTop: 12 }}>Insights on digital finance, development, and innovation in Africa.</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24, marginBottom: 40 }}>
          {posts.slice(0, 3).map(post => (
            <Link key={post.id} to={`/blog/${post.id}`} style={{
              textDecoration: 'none',
              background: '#fff', borderRadius: 14,
              border: '1px solid #E2E8F0', overflow: 'hidden',
              boxShadow: '0 2px 12px rgba(10,37,64,0.07)',
              transition: 'all 0.3s', display: 'block',
            }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(124,77,255,0.16)';
                e.currentTarget.style.borderColor = E;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = '0 2px 12px rgba(10,37,64,0.07)';
                e.currentTarget.style.borderColor = '#E2E8F0';
              }}
            >
              {post.coverImageUrl && (
                <div style={{ height: 180, overflow: 'hidden' }}>
                  <img src={post.coverImageUrl} alt={post.title}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
              )}
              {!post.coverImageUrl && (
                <div style={{
                  height: 180,
                  background: `linear-gradient(135deg, ${N} 0%, #0D3060 60%, #003828 100%)`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <i className="fas fa-book-open" style={{ color: 'rgba(255,255,255,0.25)', fontSize: '3rem' }} />
                </div>
              )}
              <div style={{ padding: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10, alignItems: 'center' }}>
                  {post.category && (
                    <span style={{
                      background: 'rgba(124,77,255,0.10)', color: ED,
                      fontSize: '0.75rem', fontWeight: 700, padding: '3px 10px', borderRadius: 20,
                      border: '1px solid rgba(124,77,255,0.25)',
                    }}>
                      {post.category}
                    </span>
                  )}
                  <span style={{ color: '#718096', fontSize: '0.78rem' }}>
                    {post.publishedAt ? new Date(post.publishedAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : ''}
                  </span>
                </div>
                <h3 style={{ color: N, fontSize: '1rem', fontWeight: 700, lineHeight: 1.4, marginBottom: 8 }}>
                  {post.title}
                </h3>
                <p style={{ color: '#718096', fontSize: '0.85rem', lineHeight: 1.6 }}>
                  {post.excerpt?.substring(0, 100)}...
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div style={{ textAlign: 'center' }}>
          <Link to="/blog" style={{
            background: E, color: '#fff', padding: '12px 28px',
            borderRadius: 8, fontWeight: 700, fontSize: '0.95rem',
            display: 'inline-flex', alignItems: 'center', gap: 8,
            boxShadow: '0 4px 18px rgba(124,77,255,0.28)',
            transition: 'all 0.2s',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = ED; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = E;  e.currentTarget.style.transform = 'none'; }}
          >
            View All Posts <i className="fas fa-arrow-right" />
          </Link>
        </div>
      </div>
    </section>
  );
}
